// Gate de tela dos módulos de produto (Meet/Campanhas/Marketing R$47/mês,
// Ligações R$197/mês): no mount, consulta o estado do módulo e — se a conta
// não tem — abre o paywall BLOQUEANTE (fechar volta pra tela anterior).
// Grandfather/override nunca veem nada.
import { onMounted } from 'vue';
import { emitter } from 'shared/helpers/mitt';
import BillingAPI from 'dashboard/api/billing';

// Aceita um módulo ou uma lista: com lista, basta UM ativo para liberar, e o
// paywall cobra o PRIMEIRO da lista (o mais provável de o cliente querer).
// Existe porque conectar conta de anúncio vale para Captação ou Estúdio Social
// — exigir só o segundo travou 28 contas que pagavam Captação pelos painéis.
export function useModuleGate(moduleKeys) {
  const keys = Array.isArray(moduleKeys) ? moduleKeys : [moduleKeys];

  onMounted(async () => {
    try {
      const { data } = await BillingAPI.getModules();
      const modules = data?.modules;
      if (!modules) return;

      // Módulo ausente na resposta não é "desligado": só bloqueia quando o
      // backend diz explicitamente que não tem.
      const anyEnabled = keys.some(key => modules[key]?.enabled !== false);
      if (anyEnabled) return;

      emitter.emit('showModulePaywall', { module: keys[0], blocking: true });
    } catch {
      // sem dado de módulo (erro transitório): não bloqueia a tela
    }
  });
}
